import {
  Home as HomeIcon, BugReport as BugReportIcon, ManageAccounts as ManageAccountsIcon, Category as CategoryIcon, Quiz as QuizIcon, ContactSupport as ContactSupportIcon,
  Assessment as AssessmentIcon,
  Summarize as SummarizeIcon,
  ShoppingCart as ShoppingCartIcon,
  CalendarMonth as CalendarMonthIcon,
  List as ListIcon,
  Inventory as InventoryIcon,
  LocalShipping as LocalShippingIcon,
  Add as AddIcon,
  AddTask as AddTaskIcon,
  CalendarViewDayRounded as CalendarViewDayIcon,
  HelpCenter,
  Payment as PaymentIcon,
  AccountBalance as RoyaltyIcon,
  Receipt as InvoiceIcon, Autorenew as StatusIcon,
  Forest as PlantationIcon, Group as StakeHolderMappingIcon,
  BrowserUpdated as ResourceUpdateIcon, ManageAccounts as ManageIcon,
  Folder as FolderIcon, MonetizationOn as MonetizationOnIcon, MultipleStop as MultipleStopIcon, SwitchAccount as DbsIcon, TrackChanges as TrackIcon,
  Approval
} from '@mui/icons-material';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import MobiledataOffIcon from '@mui/icons-material/MobiledataOff';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import LanIcon from '@mui/icons-material/Lan';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BadgeIcon from '@mui/icons-material/Badge';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { ROLES } from './constants';
import ReportIcon from '@mui/icons-material/Report';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import BlockIcon from '@mui/icons-material/Block';
export const tabsConstants = [
  {
    functionName: "Admin Resource onboarding",
    title: 'Onboarding',
    path: '/sidebar/onboardingStakeholders',
    icon: <HowToRegIcon />,
    order: 1.10,
  },
  {
    functionName: "Admin Registration",
    title: 'Registration',
    path: '/sidebar/viewAllActiveApplications',
    icon: <StatusIcon />,
    order: 2,
  },
  {
    functionName: 'Resource onboarding',
    title: 'Onboarding',
    path: '/registrationHome/onboarding',
    icon: <HowToRegIcon />,
    order: 4,
  },
  {
    functionName: 'Pre-reg',
    title: 'Pre-Registration',
    path: '/registrationHome/preregistration',
    icon: <HistoryEduIcon />,
    order: 2,
  },
  {
    functionName: 'Shortlisting',
    title: 'Shortlisting',
    path: '/registrationHome/shortlisting',
    icon: <MobiledataOffIcon />,
    order: 3,
  },
  {
    functionName: 'Registration',
    title: 'Registration',
    path: '/registrationHome/registration',
    icon: <HowToRegIcon />,
    order: 7,
  },
  {
    functionName: 'Scrutiny',
    title: 'Scrutiny',
    path: '/registrationHome/scrutiny',
    icon: <PendingActionsIcon />,
    order: 6,
  },
  {
    functionName: 'Smart card issuance',
    title: 'Smart Card Issuance',
    path: '/registrationHome/smartCardIssuance',
    icon: <CardMembershipIcon />,
    order: 8,
  },
  {
    functionName: 'Smart card print',
    title: 'Card Generation',
    path: '/registrationHome/cardGeneration',
    icon: <CreditCardIcon />,
    order: 10,
  },
  {
    functionName: 'E-Smart card download',
    title: 'E-Smart card download',
    path: '/registrationHome/eSmartCardDownload',
    icon: <BadgeIcon />,
    order: 9,
  },
  {
    functionName: 'Reg-Reports',
    title: 'Reports',
    path: '/registrationHome/reports',
    icon: <AssessmentIcon />,
    order: 11,
  },
  {
    functionName: 'Dashboard',
    title: 'Dashboard',
    path: '/registrationHome/dashboard',
    icon: <DashboardIcon />,
    order: 1,
  },
  {
    functionName: 'Supervisor Dashboard',
    title: 'Dashboard',
    path: '/registrationHome/supervisorDashboard',
    icon: <DashboardIcon />,
    order: 1,
  },
  {
    functionName: 'Mapping',
    title: 'Mapping',
    path: '/registrationHome/mapping',
    icon: <LanIcon />,
    order: 5,
  },
  {
    functionName: 'Advance payment',
    title: 'Advance Payment',
    path: '/paymentDashboard/advancePayment',
    icon: <PaymentIcon />,
    order: 1
  },
  {
    functionName: 'Royalty payment',
    title: 'Royalty Payment',
    path: '/paymentDashboard/royaltyPayment',
    icon: <RoyaltyIcon />,
    order: 2
  },
  {
    functionName: 'Invoice payment',
    title: 'Invoice Payment',
    path: '/paymentDashboard/invoicePayment',
    icon: <InvoiceIcon />,
    order: 3
  },
  {
    functionName: 'Payment status/reports',
    title: 'Payment Status',
    path: '/paymentDashboard/PaymentStatusABRPLUser',
    icon: <StatusIcon />,
    order: 4
  },
  {
    functionName: 'Payment Reports',
    title: 'Payment Reports',
    path: '/paymentDashboard/Paymentreport',
    icon: <AssessmentIcon />,
    order: 200
  },

  // ======================PIT======================
  // {
  //   functionName: "Workflow Dashboard",
  //   title: "Workflow Dashboard",
  //   path: '/',
  //   icon: <HomeIcon />,
  //   order: 1
  // },
  {
    functionName: "Workflow Dashboard",
    title: "Workflow Dashboard",
    path: '/pitWorkflowDashboard',
    icon: <HomeIcon />,
    order: 1
  },
  {
    functionName: "Transportation Dashboard",
    title: 'Transportation Dashboard',
    path: '/trDashboard',
    icon: <DashboardIcon />,
    order: 2,
  },
  {
    functionName: "Inventory Dashboard",
    title: 'Inventory Dashboard',
    path: '/inventoryDashboard',
    icon: <DashboardIcon />,
    order: 3,
  },
  {
    functionName: "Manual PO Creation",
    title: "Manual PO Creation",
    path: '/manualPoCreation',
    icon: <AddIcon />,
    order: 4,
  },
  {
    functionName: "Manual Schedule Creation",
    title: "DBS Schedule Creation",
    path: '/dbsScheduleCreation',
    icon: <AddIcon />,
    order: 5,
  },
  {
    functionName: "HIT Manual Schedule",
    title: "HIT Schedule Creation",
    path: '/manualScheduleCreation',
    icon: <AddIcon />,
    order: 6,
  },
  {
    functionName: "LLE Manual Schedule",
    title: "LLE Schedule Creation",
    path: '/lleScheduleCreation',
    icon: <AddIcon />,
    order: 7,
  },
  {
    functionName: "LLE chipping schedule",
    title: "LLE Chipping Schedule Creation",
    path: '/lleScheduleCreation',
    icon: <AddIcon />,
    order: 7,
  },
  {
    functionName: "Transporter Manual Schedule",
    title: "Transporter Schedule Creation",
    path: '/transporterScheduleCreation',
    icon: <AddIcon />,
    order: 8,
  },
  {
    functionName: "PO Approval",
    title: "PO Approval",
    path: '/poApproval',
    icon: <AddTaskIcon />,
    order: 9,
  },
  {
    functionName: "STO Approval",
    title: "STO Approval",
    path: '/stoApproval',
    icon: <AddTaskIcon />,
    order: 10,
  },
  {
    functionName: "SCO Approval",
    title: "SCO Approval",
    path: '/scoApproval',
    icon: <AddTaskIcon />,
    order: 100,
  },
  {
    functionName: "PO List",
    title: "PO List",
    path: '/poList',
    icon: <ListIcon />,
    order: 11,
  },
  {
    functionName: "STPO List",
    title: "STO List",
    path: '/stoList',
    icon: <ListIcon />,
    order: 50,
  },
  {
    functionName: "SCO List",
    title: "SCO List",
    path: '/scoList',
    icon: <ListIcon />,
    order: 12,
  },
  {
    functionName: "PO STPO Generation",
    title: 'Monthly Allocation',
    path: '/demandDashboard/monthlyAllocation',
    icon: <AssessmentIcon />,
    order: 13,
  },
  {
    functionName: "Expected Plant Consumption",
    title: 'Expected Plant Consumption',
    path: '/plantconsumption',
    icon: <AssessmentIcon />,
    order: 14,
  },
  {
    functionName: "Consolidated Weekly Schedule",
    title: 'Consolidated Weekly Plans',
    path: '/plantSchedule',
    icon: <CalendarViewDayIcon />,
    order: 15,
  },

  {
    functionName: "Actual Plant Consumption",
    title: 'Actual Plant Consumption',
    path: '/plantCBConsumption',
    icon: <AssessmentIcon />,
    order: 16,
  },
  {
    functionName: "Weekly schedule RB Approval",
    title: "Weekly schedule RB Approval",
    path: '/rbScheduleApproval',
    icon: <AddTaskIcon />,
    order: 17,
  },
  {
    functionName: "Weekly schedule CB Approval",
    title: "Weekly schedule CB Approval",
    path: '/cbScheduleApproval',
    icon: <AddTaskIcon />,
    order: 18,
  },
  {
    functionName: "Weekly schedule Chipping Approval",
    title: 'Weekly schedule Chipping Approval',
    path: '/chippingApproval',
    icon: <AssessmentIcon />,
    order: 19,
  },
  {
    functionName: "Consignment List",
    title: "Consignment List",
    path: '/consignmentList',
    icon: <ListIcon />,
    order: 20,
  },
  {
    functionName: "RB Consignment",
    title: "RB Consignment Creation",
    path: '/consignmentCreation',
    icon: <AddIcon />,
    order: 21,
  },
  {
    functionName: "CB Consignment",
    title: "CB Consignment Creation",
    path: '/ChippingConsignmentCreation',
    icon: <AddIcon />,
    order: 22,
  },
  {
    functionName: "RB PickUp/ Tracker",
    title: "HIT Pickup/Tracker",
    path: '/ConsignmentPickUp',
    icon: <AutoModeIcon />,
    order: 23,
  },
  {
    functionName: "CB Pickup/Tracker",
    title: "Dispatch Pickup/Tracker",
    path: '/inventoryType',
    icon: <LocalShippingIcon />,
    order: 24,
  },
  {
    functionName: "ASN",
    title: "ASN's",
    path: '/asnGRN',
    icon: <ListIcon />,
    order: 25,
  },
  {
    functionName: "ASN Correction",
    title: "ASN Correction",
    path: '/asnCorrection',
    icon: <ListIcon />,
    order: 25.1,
  },
  {
    functionName: "ASN Correction Approval",
    title: "ASN Correction Approval",
    path: '/asnCorrectionApproval',
    icon: <Approval />,
    order: 25.2,
  },
  {
    functionName: "Send Back for ASN Correction",
    title: "Send Back for ASN Correction",
    path: '/asnSendForCorrection',
    icon: <Approval />,
    order: 25.3,
  },
    {
    functionName: "ASN Correction Approval List",
    title: "ASN Correction Approval List",
    path: '/asnCorrectionApproval',
    icon: <Approval />,
    order: 25.4,
  },
  {
    functionName: "GRN",
    title: "GRN List",
    path: '/grnList',
    icon: <ListIcon />,
    order: 26,
  },
  {
    functionName: 'GRN Approval',
    title: "GRN Approval",
    path: '/grnApprove',
    icon: <AddTaskIcon />,
    order: 27,
  },
  {
    functionName: "Chipping order",
    title: 'Chipping Orders',
    path: '/chippingOrders',
    icon: <ListIcon />,
    order: 28,
  },

  {
    functionName: "Plant Chipping Order",
    title: 'Plant Chipping Order',
    path: '/PlantChippingOrders',
    icon: <ListIcon />,
    order: 29,
  },
  {
    functionName: "Inventory Ledger",
    title: 'Inventory Ledger',
    path: '/LnvLedger',
    icon: <InventoryIcon />,
    order: 30,
  },
  {
    functionName: "Delivery Challan",
    title: 'Delivery Challan',
    path: '/deliveryChalanList',
    icon: <InvoiceIcon />,
    order: 31,
  },
  {
    functionName: "RB Challan List",
    title: 'RB Challan List',
    path: '/rbChalanList',
    icon: <InvoiceIcon />,
    order: 31.1,
  },
  {
    functionName: "Harvesting Details",
    title: 'Harvesting Details',
    path: '/scheduleHarvestingDetails',
    icon: <AssessmentIcon />,
    order: 32,
  },
  {
    functionName: "Bidding List",
    title: "Bidding List",
    path: '/biddingApprovalList',
    icon: <ListIcon />,
    order: 33,
  },
  {
    functionName: "Approve Spot Bidding Allotment Request",
    title: "Approve Spot Bidding Allotment Request",
    path: '/spotBiddingApproval',
    icon: <AutoModeIcon />,
    order: 34,
  },
  {
    functionName: "Approve Vehicle Block Request",
    title: "Approve Vehicle Block Request",
    path: '/approveVehicleBlockRequest',
    icon: <AutoModeIcon />,
    order: 34.05,
  },

  {
    functionName: "Bidding Allotment Requests",
    title: "Bidding Allotment Requests",
    path: '/biddingAllotmentRequests',
    icon: <AutoModeIcon />,
    order: 34.1,
  },

  {
    functionName: "Release Allotment Request",
    title: "Release Allotment Request",
    path: '/biddingSelection',
    icon: <ArrowOutwardIcon />,
    order: 35,
  },

  {
    functionName: "SES",
    title: 'SES',
    path: '/dashboardHome/sesList',
    icon: <ListIcon />,
    order: 36,
  },
  {
    functionName: "SES Approval",
    title: 'SES Approval',
    path: '/dashboardHome/sesApproval',
    icon: <AddTaskIcon />,
    order: 37,
  },

  {
    functionName: "SO Approval",
    title: " SO Approval",
    path: '/servicePOApprovalList',
    icon: <AddTaskIcon />,
    order: 38,
  },

  {
    functionName: "SO List",
    title: " SO List",
    path: '/soList',
    icon: <ListIcon />,
    order: 39,
  },

  {
    functionName: "PIT Consignment Issue",
    title: "Consignment Issue",
    path: '/consignmentIssueList',
    icon: <ListIcon />,
    order: 40,
  },
  {
    functionName: "PIT Inventory Issue",
    title: "PIT Inventory Issue",
    path: '/inventoryIssueList',
    icon: <ListIcon />,
    order: 41,
  },
  {
    functionName: "Unloader Mapping",
    title: "Weighbridge Mapping",
    path: '/sidebar/wboUnloaderMappingList',
    icon: <ListIcon />,
    order: 42,
  },

  {
    functionName: "Consignment Vehicle tracking",
    title: "Consignment Vehicle tracking",
    path: '/consignmentVehicleTracking',
    icon: <AutoModeIcon />,
    order: 43,
  },
  {
    functionName: "DBS ASN",
    title: "DBS ASN",
    path: '/dbsAsn',
    icon: <ListIcon />,
    order: 44,
  },
  {
    functionName: "Generate SES",
    title: "Generate SES",
    // path: '/generateSes',
    path: '/generateInvoice',
    icon: <ListIcon />,
    order: 45,
  },
  {
    functionName: "Consignment Pickup Tracker",
    title: "Consignment Pickup Tracker",
    path: '/consignmentPickupTracker',
    icon: <TrackIcon />,
    order: 46,
  },
  {
    functionName: "User Approval",
    title: "User Approval",
    path: '/userOnboardingApproval',
    icon: <AddTaskIcon />,
    order: 47,
  },
  {
    functionName: "PIT-Reports",
    title: "Reports",
    path: '/pitReports',
    icon: <AssessmentIcon />,
    order: 120,
  },
  {
    functionName: "Stock Transfer Request",
    title: "Stock Transfer Request",
    path: '/stockTransferRequest',
    icon: <AddIcon />,
    order: 108,
  },
  {
    functionName: "Stock Transfer Request List",
    title: "Stock Transfer Request List",
    path: '/stockTransferList',
    icon: <AddIcon />,
    order: 109,
  },

  {
    functionName: "Approve Stock Transfer Request",
    title: "Stock Transfer Request Approval",
    path: '/stockTransferReqApproval',
    icon: <AddTaskIcon />,
    order: 110,
  },
  {
    functionName: "Non Transporter Stock Transfer",
    title: "Non Transporter Stock Transfer",
    path: '/nonTransporterStockTransfer',
    icon: <MoveDownIcon />,
    order: 111,
  },
  {
    functionName: "Plant chipping schedule",
    title: "Plant Chipping Schedule Creation",
    path: '/plantChippingScheduleCreation',
    icon: <AddIcon />,
    order: 8.2,
  },
  {
    functionName: "Spot Bidding Allotment Request",
    title: "Spot Bidding Allotment Request",
    path: '/spotBiddingRequest',
    icon: <AddIcon />,
    order: 112,
  },
  {
    functionName: "Bidding Acceptance Report",
    title: "Bidding Acceptance Report",
    path: '/biddingAcceptanceReport',
    icon: <AddIcon />,
    order: 113,
  },
  {
    functionName: "Block Unblock Vehicles",
    title: "Block Unblock Vehicles",
    path: '',
    icon: <BlockIcon />,
    order: 114,
  },
  {
    functionName: "Block Vehicles",
    title: "Block Vehicles",
    path: '/blockVehicle',
    icon: <BlockIcon />,
    order: 114.1,
  },
  {
    functionName: "Unblock Vehicles",
    title: "Approve Unblock Vehicles Request",
    path: '/approveUnlockVehicleRequest',
    icon: <BlockIcon />,
    order: 114.2,
  },
  {
    functionName: "Consignment Cancellation Approval",
    title: "Consignment Cancellation Approval",
    path: '/consignmentCancellationApproval',
    icon: <BlockIcon />,
    order: 115,
  },
  {
    functionName: "PO Report",
    title: "PO Report",
    path: '/poReport',
    icon: <ReportIcon />,
    order: 116,
  },
  /*=============================== Quality Module =====================*/

  {
    functionName: "Quality Dashboard",
    title: 'Dashboard',
    path: '/qualitydashboard/home',
    icon: <HomeIcon />,
    order: 1,
  },
  {
    functionName: "Manage Tolerance",
    title: 'Manage Tolerance Limit',
    path: '/qualitydashboard/managetolerance',
    icon: <ManageAccountsIcon />,
    order: 2,
  },
  {
    functionName: "Inspection Order",
    title: 'Inspection Work Order',
    path: '/qualitydashboard/inspectionworkorder',
    icon: <CategoryIcon />,
    order: 3,
  },
  {
    functionName: "Issue",
    title: 'Issue & ATC',
    path: '/qualitydashboard/issueatc',
    icon: <QuizIcon />,
    order: 5,
  },
  {
    functionName: "Worklist",
    title: 'Worklist',
    path: '/qualitydashboard/manageWorkList',
    icon: <MultipleStopIcon />,
    order: 4,
  },
  {
    functionName: "Quality Reports",
    title: 'Reports',
    path: '/qualitydashboard/qualityReports',
    icon: <ReportIcon />,
    order: 6,
  },
  /*=============================== HelpDesk Module =====================*/

  {
    functionName: "Manage FAQ",
    title: 'Manage FAQ',
    path: '/helpDeskDashboard/manage-faq',
    icon: <QuizIcon />,
    order: 5,
  },
  {
    functionName: "Helpdesk Reports",
    title: 'Reports',
    path: '/helpDeskDashboard/helpdeskReports',
    icon: <QuizIcon />,
    order: 48,
  },
  {
    functionName: "Helpdesk Dashboard",
    title: 'Home',
    path: '/helpDeskDashboard/helpDeskDashboard',
    icon: <HomeIcon />,
    order: 1,

  },
  {
    functionName: "Manage SLA",
    title: 'Manage SLA',
    path: '/helpDeskDashboard/manage-category',
    icon: <CategoryIcon />,
    order: 4,
  },
  {
    functionName: "FAQS",
    title: 'FAQs',
    path: '/helpDeskDashboard/faqs',
    icon: <ContactSupportIcon />,
    order: 6,
  },
  {
    functionName: "Manage helpdesk user",
    title: 'Manage Helpdesk User',
    path: '/helpDeskDashboard/manage-helpdesk-user',
    icon: <ManageAccountsIcon />,
    order: 7,
  },
  {
    functionName: "Manage holiday list",
    title: 'Manage Holiday List',
    path: '/helpDeskDashboard/holiday-list',
    icon: <CalendarMonthIcon />,
    order: 8,
  },
  {
    functionName: "Requests",
    title: 'Requests',
    path: '/helpDeskDashboard/requests',
    icon: <ReportIcon />,
    order: 2,
  },
  /*=============================== Demand Module =====================*/
  {
    functionName: "Annual planning",
    title: 'Configure Annual planning',
    path: '/demandDashboard/yearlyInput',
    icon: <HomeIcon />,
    order: 1,

  },
  {
    functionName: "Monthly planning",
    title: 'Configure Monthly Data',
    path: '/demandDashboard/monthlyPlanning',
    icon: <CalendarMonthIcon />,
    order: 2,
  },
  {
    functionName: "Shortlist Stakeholders",
    title: 'Shortlist Stakeholders',
    path: '/demandDashboard/monthlyPlanning',
    icon: <ReportIcon />,
    order: 2.1,
  },
  {
    functionName: "Grower Clustering",
    title: 'Grower Clustering',
    path: '/demandDashboard/growerClustering',
    icon: <ReportIcon />,
    order: 2.2,
  },
  {
    functionName: "Monthly Mappings",
    title: 'Monthly Mappings',
    path: '/demandDashboard/monthlyMapping',
    icon: <ReportIcon />,
    order: 2.3,
  },
  {
    functionName: "Monthly Allocation",
    title: 'Monthly Allocation',
    path: '/demandDashboard/monthlyAllocation',
    icon: <ReportIcon />,
    order: 2.4,
  },
  {
    functionName: "Manage Constraints",
    title: 'Manage Constraints',
    path: '/demandDashboard/manageMbr',
    icon: <ShoppingCartIcon />,
    order: 3,
  },
  {
    functionName: "MBR setup",
    title: 'Stakeholder MBR',
    path: '/demandDashboard/manageMbr',
    icon: <ReportIcon />,
    order: 3.1,
  },
  {
    functionName: "MBR workflow",
    title: 'Stakeholder MBR',
    path: '/demandDashboard/mbrWorkflow',
    icon: <ReportIcon />,
    order: 3.2,
  },
  {
    functionName: "LLE Chipping Capacity",
    title: 'LLE Chipping Capacity',
    path: '/demandDashboard/lleChippingCapacity',
    icon: <ReportIcon />,
    order: 3.2,
  },
  {
    functionName: "LLE Harvesting Potential",
    title: 'LLE Harvesting Potential',
    path: '/demandDashboard/lleAnnualHarvestingPotential',
    icon: <ReportIcon />,
    order: 3.3,
  },
  {
    functionName: "Safety Stock",
    title: 'Safety Stock Pile',
    path: '/demandDashboard/safetyStockPile',
    icon: <ReportIcon />,
    order: 3.4,
  },
  {
    functionName: "Dmd-Reports",
    title: 'Reports',
    path: '/demandDashboard/demandReports',
    icon: <ReportIcon />,
    order: 400,
  },

  /*=============================== Resource Module =====================*/
  {
    functionName: "Workflow",
    title: 'Workflow',
    path: '/resourcedashboard/home',
    icon: <HomeIcon />,
    order: 1,
  },
  {
    functionName: "Sent for approval",
    title: 'Sent for Approval',
    path: '/resourcedashboard/sentForApproval',
    icon: <ReportIcon />,
    order: 1.1,
  },
  {
    functionName: "All worklist",
    title: 'All worklist',
    path: '/resourcedashboard/allWorkList',
    icon: <ReportIcon />,
    order: 1.2,
  },
  {
    functionName: "Stakeholder Mapping",
    title: 'Stakeholder Mapping',
    path: '/resourcedashboard/adminhome',
    icon: <StakeHolderMappingIcon />,
    order: 2,
  },
  {
    functionName: "Add Stakeholder Mapping",
    title: 'Add Stakeholder Mapping',
    path: '/resourcedashboard/selectStakeHolder',
    icon: <ReportIcon />,
    order: 2.1,
  },
  {
    functionName: "Grower-HIT Stakeholder Mapping",
    title: 'Grower-HIT Stakeholder Mapping',
    path: '/resourcedashboard/growerHitMapping',
    icon: <ReportIcon />,
    order: 2.2,
  },
  {
    functionName: "Transporter Stakeholder Mapping",
    title: 'Transporter Stakeholder Mapping',
    path: '/resourcedashboard/selectTransporterStakeholder',
    icon: <ReportIcon />,
    order: 2.3,
  },
  {
    functionName: "View Transporter Mapping Routes",
    title: 'View Transporter Mapping Routes',
    path: '/resourcedashboard/viewTransporterMappingRoutes',
    icon: <ReportIcon />,
    order: 2.4,
  },
  {
    functionName: "Unmapped Stakeholder Dashboard",
    title: "Unmapped Stakeholder Dashboard",
    path: '/resourcedashboard/unmappedStakeholderDashboard',
    icon: '',
    order: 2.5,
  },
  {
    functionName: "Knowledgement Management",
    title: 'Knowledge Management',
    path: '/resourcedashboard/plantScmKnowledgeManagement',
    icon: <FolderIcon />,
    order: 3,
  },
  {
    functionName: "Add Training Material",
    title: 'Add Training Material',
    path: '/resourcedashboard/plantScmKnowledgeManagement/scmMemberUploadFile',
    icon: <ReportIcon />,
    order: 3.1,
  },
  {
    functionName: "View/Download Training Material",
    title: 'View/Download Training Material',
    path: '/resourcedashboard/plantScmKnowledgeManagement/viewKnowledgeManagement',
    icon: <ReportIcon />,
    order: 3.2,
  },
  {
    functionName: "Plantation",
    title: 'Plantation',
    path: '/resourcedashboard/plantationHome',
    icon: <PlantationIcon />,
    order: 5,
  },
  {
    functionName: "Create Plantation Batch",
    title: 'Create Plantation Batch',
    path: '/resourcedashboard/plantationHome/scmMemberCreatePlant',
    icon: <ReportIcon />,
    order: 5.1,
  },
  {
    functionName: "View/Update Plantation Batch",
    title: 'View/Update Plantation Batch',
    path: '/resourcedashboard/plantationHome/allPlantBatch',
    icon: <ReportIcon />,
    order: 5.2,
  },
  {
    functionName: "Rate Card",
    title: 'Rate Card',
    path: '/resourcedashboard/rateCard',
    icon: <MonetizationOnIcon />,
    order: 4,
  },
  {
    functionName: "Rate Card Confirmation",
    title: 'Rate Card Confirmation',
    path: '/resourcedashboard/rateCard/rateCardConfirmation',
    icon: <ReportIcon />,
    order: 4.1,
  },
  {
    functionName: "Add Rate Card",
    title: 'Add Rate Card',
    path: '/resourcedashboard/rateCard/createRateCard',
    icon: <ReportIcon />,
    order: 4.2,
  },
    {
    functionName: "Grower LLE Rate",
    title: 'Rate Card based on mapped LLE/Plant',
    path: '/resourcedashboard/rateCard/growerLleRateCard',
    icon: <ReportIcon />,
    order: 4.3,
  },
  {
    functionName: "Rate Card Mass Entry",
    title: 'Rate Card Mass Entry',
    path: '/resourcedashboard/rateCard/rateCardMassEntry',
    icon: <ReportIcon />,
    order: 4.4,
  },
  {
    functionName: "View and Update Approved Rates",
    title: 'View Approved Rates',
    path: '/resourcedashboard/rateCard/editRateCard',
    icon: <ReportIcon />,
    order: 4.5,
  },
  {
    functionName: "Resource update",
    title: 'Resource update',
    path: '/resourcedashboard/searchByURN',
    icon: <ResourceUpdateIcon />,
    order: 6,
  },
  {
    functionName: "LOV",
    title: ' Manage LOV',
    path: '/resourcedashboard/managePlantationLOV',
    icon: <ManageIcon />,
    order: 7,
  },
  {
    functionName: "Aggregator HIT mapping",
    title: 'Aggregator HIT mapping',
    path: '/resourcedashboard/aggregatorMapping',
    icon: <StakeHolderMappingIcon />,
    order: 7.1,
  },
  {
    functionName: "Manage Constraints",
    title: 'Constraints Manage',
    path: '/resourcedashboard/adminhome',
    icon: <ShoppingCartIcon />,
    order: 8
  },
  {
    functionName: "LLE/IS Storage Capacity",
    title: 'LLE/IS Storage Capacity   ',
    path: '/resourcedashboard/storageCapacity',
    icon: <SummarizeIcon />,
    order: 8.1,
  },
  {
    functionName: "Payment Details",
    title: 'Payment Details',
    path: '/resourcedashboard/paymentDetails',
    icon: <PaymentIcon />,
    order: 9
  },
  {
    functionName: "DBS",
    title: 'DBS Selection',
    path: '/resourcedashboard/dbs',
    icon: <DbsIcon />,
    order: 10,
  },
  {
    functionName: "ResScrutinizerMapping",
    title: 'Scrutinizer Boarding',
    path: '/resourcedashboard/mapping',
    icon: <LanIcon />,
    order: 11,
  },
  {
    functionName: "Res-Reports",
    title: 'Reports',
    path: '/resourcedashboard/resourceReports',
    icon: <ReportIcon />,
    order: 80,
  },

]